import { setPracticumValue } from "../../../../../features/Practicum/redux/slice";
import { PracticumValue } from "../../../../api/instances/practicumApi/types";
import { ServiceHandler } from "./storageHandlers";

export const PracticumService: ServiceHandler = {
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    listenerApi.dispatch(setPracticumValue(value as PracticumValue));
  },
};
